var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4901 3.22731L5.50015 5.09731C4.35015 5.52731 3.41016 6.88731 3.41016 8.11731V15.5473C3.41016 16.7273 4.19017 18.2773 5.14017 18.9873L9.44016 22.1973C10.8502 23.2573 13.1701 23.2573 14.5801 22.1973L18.8802 18.9873C19.8302 18.2773 20.6101 16.7273 20.6101 15.5473V8.11731C20.6101 6.88731 19.6701 5.52731 18.5201 5.09731L13.5302 3.22731C12.6802 2.91731 11.3201 2.91731 10.4901 3.22731Z",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.4973C14.2091 16.4973 16 14.7065 16 12.4973C16 10.2882 14.2091 8.49731 12 8.49731C9.79086 8.49731 8 10.2882 8 12.4973C8 14.7065 9.79086 16.4973 12 16.4973Z",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 11.2473V12.1773C12.25 12.5273 12.07 12.8573 11.76 13.0373L11 13.4973",
    stroke: "#D96122",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCard);
export default __webpack_public_path__ + "static/media/time-card.aa096f96ad3c5a3e47182c4e56ff69fc.svg";
export { ForwardRef as ReactComponent };